import React from 'react'
import { Box } from '@mui/material'
import { Drawer, Loader } from 'packages/eid-ui'
import ItemHeader from '../../ItemHeader'
import { isNilOrEmpty, useIsSmallScreen } from 'packages/core'
import { useAzureRole, useTargetPerson } from 'hooks'
import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import AzureAdminRoleDetails from './AzureAdminRoleDetails'
import { catalogDetailsDrawerExplainProps } from '../../catalogDetailsDrawerExplain'

const AzureAdminRoleDrawer = ({ id, toggleDrawer, attributes }) => {
    const isSmallScreen = useIsSmallScreen()
    const [targetPerson] = useTargetPerson()

    const { data: azureAdminRole } = useAzureRole(id, targetPerson?.id)

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <Box
                {...catalogDetailsDrawerExplainProps('Azure admin role')}
            >
                <ItemHeader title={azureAdminRole?.friendlyName} />
                {!azureAdminRole && <Loader />}
                {azureAdminRole && (
                    <AzureAdminRoleDetails
                        toggleDrawer={toggleDrawer}
                        attributes={attributes}
                        azureAdminRole={azureAdminRole}
                    />
                )}
            </Box>
        </ItemsDetailsMobileWrapper>
    ) : (
        <Drawer
            width="clamp(67%, 1007px, 90%)"
            open={!isNilOrEmpty(id)}
            toggleDrawer={toggleDrawer}
            stickyHeader
            header={<ItemHeader title={azureAdminRole?.friendlyName} />}
            closeOnOutsideClick
        >
            <Box
                {...catalogDetailsDrawerExplainProps('Azure admin role')}
            >
                {!azureAdminRole && <Loader />}
                {azureAdminRole && (
                    <AzureAdminRoleDetails
                        toggleDrawer={toggleDrawer}
                        attributes={attributes}
                        azureAdminRole={azureAdminRole}
                    />
                )}
            </Box>
        </Drawer>
    )
}

export default AzureAdminRoleDrawer
